import React from 'react';
import { useNavigate } from 'react-router-dom';

import Error from '@src/components/DirectLink/Error';
import { CartCheckout, CartDetailsBody } from '@src/features/cart';
import { useCartLinkError } from '@src/features/direct-link/availability';

type SaleProps = {
  showErrors?: boolean;
};

export const SalePreview = (props: SaleProps) => {
  const { showErrors = true } = props;
  const navigate = useNavigate();
  const error = useCartLinkError();

  return (
    <>
      {error ? (
        <Error>{error}</Error>
      ) : (
        <>
          <CartDetailsBody
            editable={false}
            showBackButtonIfEmpty={false}
            showEmptyInstruction={false}
            showErrors={showErrors}
          />

          <CartCheckout
            enableCoupon={false}
            proceedWithErrors={true}
            onCheckout={() => {
              navigate('process');
            }}
          />
        </>
      )}
    </>
  );
};

export default SalePreview;
